import useToken from "../../hooks/useToken";

function createDataProvider() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getValidToken } = useToken();
  const fetchWithAuth = async (url, options = {}) => {
    const token = await getValidToken();

    options.headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, options);
    const json = await response.json();

    return json;
  };

  const dataProvider = {
    getList: async (resource, _params) => {
      const url = `/api/admin/${resource}`;
      const json = await fetchWithAuth(url);
      // json == array
      return {
        data: json,  // list of records
        total: json.length, // total count for pagination
      };
    },

    getOne: async (resource, params) => {
      const url = `/api/admin/${resource}/${params.id}`;
      const json = await fetchWithAuth(url);
      return { data: json };
    },

    create: async (resource, params) => {
      const url = `/api/admin/${resource}`;
      const json = await fetchWithAuth(url, {
        method: 'POST',
        body: JSON.stringify(params.data),
      });
      return { data: json };
    },

    update: async (resource, params) => {
      const url = `/api/admin/${resource}/${params.id}`;
      const json = await fetchWithAuth(url, {
        method: 'PUT',
        body: JSON.stringify(params.data),
      });
      return { data: json };
    },

    delete: async (resource, params) => {
      const url = `/api/admin/${resource}/${params.id}`;
      await fetchWithAuth(url, { method: 'DELETE' });
      return { data: { id: params.id } };
    },
  };


  return dataProvider;
}


export default createDataProvider;